<template>
  <div class="p-4">
    <el-table
      ref="stateTable"
      :data="states.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%"
      @select-all="handleAllRowSelection"
      @select="handleRowSelection">
      <el-table-column prop="name" label="Name" sortable></el-table-column>
      <el-table-column prop="code" label="Code" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { flatMap } from 'lodash';

export default {
  name: 'States',
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
    };
  },
  computed: {
    states() {
      return flatMap(this.$store.state.SettingsModule.Location.states);
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    handleRowSelection() {
      this.showDeleteAll = this.$refs.stateTable.selection.length > 0;
    },
    handleAllRowSelection() {
      this.showDeleteAll = this.$refs.stateTable.selection.length > 0;
    },
    clearSelection() {
      this.$refs.stateTable.clearSelection();
      this.showDeleteAll = false;
    },
    getStates() {
      try {
        this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId: this.$route.params.country_id });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getStates();
    },
    handlePageChange(args) {
      this.page = args;
      this.getStates();
    },
  },
};
</script>

<style>
</style>
